import { render, staticRenderFns } from "./GroupAdmins.vue?vue&type=template&id=da0956ba"
import script from "./GroupAdmins.vue?vue&type=script&lang=js"
export * from "./GroupAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports